import { useState, useEffect } from 'react';

const captions = [
  'Calculating the perfect event...',
  'Clearing the dance floor...',
  'Making magic happen...',
  'Bringing your event to life...',
  'Polishing the champagne flutes...',
  'Rolling out the red carpet...',
  'Perfecting every detail...',
  'Coordinating with our team...',
  'Setting the stage...',
  'Creating something special...'
];

interface LoadingOverlayProps {
  progress?: number;
}

export default function LoadingOverlay({ progress }: LoadingOverlayProps) {
  const [caption] = useState(() => captions[Math.floor(Math.random() * captions.length)]);
  const [displayProgress, setDisplayProgress] = useState(0);

  useEffect(() => {
    if (progress !== undefined) {
      setDisplayProgress(progress);
    } else {
      // Auto-increment progress simulation when no explicit progress is provided
      const interval = setInterval(() => {
        setDisplayProgress((prev) => {
          if (prev >= 95) return 95; // Cap at 95% until actual completion
          return prev + Math.random() * 3;
        });
      }, 200);

      return () => clearInterval(interval);
    }
  }, [progress]);

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur z-50 flex items-center justify-center">
      <div className="text-center px-6 max-w-md w-full">
        <div className="mb-8">
          <div className="relative w-20 h-20 mx-auto mb-6">
            {/* Background circle */}
            <svg className="w-20 h-20 transform -rotate-90" viewBox="0 0 80 80">
              <circle
                cx="40"
                cy="40"
                r="36"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
                className="text-border"
              />
              {/* Progress circle */}
              <circle
                cx="40"
                cy="40"
                r="36"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
                strokeDasharray={`${2 * Math.PI * 36}`}
                strokeDashoffset={`${2 * Math.PI * 36 * (1 - displayProgress / 100)}`}
                className="text-primary transition-all duration-300 ease-out"
                strokeLinecap="round"
              />
            </svg>
            {/* Percentage text */}
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-2xl font-bold text-foreground">
                {Math.round(displayProgress)}%
              </span>
            </div>
          </div>
        </div>
        
        <h2 className="text-xl font-bold text-foreground mb-2">
          Processing your enquiry
        </h2>
        <p className="text-sm text-muted-foreground">
          {caption}
        </p>
      </div>
    </div>
  );
}
